import * as yup from 'yup';

export const schema = yup.object().shape({
  password: yup
    .string()
    .min(6, 'Contraseña muy corta - debe contener al menos 6 caracteres.')
    .nullable()
    .required(),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Las contraseñas no coinciden')
    .required(),
});
